import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CircularProgress from '@material-ui/core/CircularProgress';
import Divider from '@material-ui/core/Divider';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

import { authUserAction, authUserInfo } from '../../actions/loginActions';
import logoTalent from '../../assets/logo/Frame 1870.png';
import { SignIn } from '../../services/users';
import { setAnalytics } from '../../utils';
import TransitionsModal from '../General/TransitionsModal';

import PasswordFirstTime from './PasswordFirstTime';

const useStyles = makeStyles((theme) => ({
  card: {
    borderRadius: '14px',
    // maxWidth: 350,
    // maxHeight: 950,
    padding: theme.spacing(3, 4, 6, 4),
    margin: theme.spacing(2, 2, 2, 6),
    background: theme.palette.common.white,
    [theme.breakpoints.between('lg', 'xl')]: {
      width: 320,
      height: 550,
    },
    [theme.breakpoints.up('xl')]: {
      width: 350,
      height: 640,
    },
  },
  imageTalent: {
    // width: '170px',
    [theme.breakpoints.up('md')]: {
      width: 130,
    },
    [theme.breakpoints.up('lg')]: {
      width: 170,
    },
  },
  titleForm: {
    fontWeight: 'normal',
    fontSize: 16,
    color: theme.palette.common.blue,
    fontFamily: 'Raleway',
    marginTop: theme.spacing(2),
  },
  titleSession: {
    fontWeight: 600,
    fontSize: 24,
    color: theme.palette.common.blue,
    fontFamily: 'Raleway',
    marginTop: theme.spacing(5),
  },
  sectionDivider: {
    background: theme.palette.common.pink,
    size: '5',
    margin: theme.spacing(1, 1, 1),
    borderBottomWidth: 4,
  },
  input: {
    background: theme.palette.background.default,
    [theme.breakpoints.up('md')]: {
      width: 220,
    },
    [theme.breakpoints.up('lg')]: {
      width: 300,
    },
    marginTop: theme.spacing(1),
    '& input[type=number]': {
      '-moz-appearance': 'textfield',
    },
    '& input[type = number]::- webkit - outer - spin - button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    '& input[type=number]::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
  },
  textError: {
    color: theme.palette.common.red,
    marginTop: theme.spacing(2),
  },
  forget: {
    fontWeight: 'normal',
    fontSize: 14,
    color: theme.palette.text.alert,
    fontFamily: 'Raleway',
    marginTop: theme.spacing(2),
    textDecoration: 'none',
    cursor: 'pointer',
  },
  icon: {
    color: 'gray',
  },
  submit: {
    color: theme.palette.background.default,
    boxShadow: theme.shadows[1],
    fontWeight: '400',
    marginTop: theme.spacing(3),
    textTransform: 'capitalize',
    padding: '6px 20px',
    background: theme.palette.background.secondary,
    fontSize: 16,
    fontFamily: 'Raleway',
    '&:hover': {
      background: theme.palette.common.pinkLigth,
    },
    '&:disabled': {
      background: theme.palette.common.gray,
    },
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}));

function Login() {
  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [isFirstLoging, setIsFirstLoging] = useState(false);
  const [open, setOpen] = useState(false);
  const [openNeedChangePassword, setOpenNeedChangePassword] = useState(false);
  const [session, setSession] = useState('');
  const [errorText, setErrorText] = useState('');
  const [loading, setLoading] = useState(false);
  const [longValidUser, setlongValidUser] = useState(true);
  const [values, setValues] = useState({
    user: '',
    password: '',
    showPassword: false,
  });

  const handleChange = (event) => {
    setlongValidUser(true);
    if (event.target.name === 'user' && event.target.value.length < 8) {
      setlongValidUser(false);
    }
    setValues({ ...values, [event.target.name]: event.target.value });
  };

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
    setAnalytics('Login', 'Btn_IniciarSesion');
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const validateIfNeedChangePassword = () => {
    setOpenNeedChangePassword(!openNeedChangePassword);
  };

  const handleNavigateForgotPassword = () => {
    navigate('/forgot');
    setValues({
      user: '',
      password: '',
      showPassword: false,
    });
  };

  const userNameOrPasswordIncorrect = 'Dato(s) incorrecto(s) o no está registrado';

  const getMessageError = (error) => {
    const errors = {
      'Incorrect username or password.': userNameOrPasswordIncorrect,
      'User does not exist.': 'Usuario no registrado',
      'Password reset required for the user': () => validateIfNeedChangePassword(),
      default: 'Lo sentimos, ocurrió un error',
    };

    return errors[error] || errors.default;
  };

  const login = async () => {
    try {
      setErrorText('');
      setLoading(true);
      const logeo = await SignIn(values.user, values.password);
      if (logeo.data !== null && logeo.data !== undefined) {
        if (logeo.data.ChallengeName === 'NEW_PASSWORD_REQUIRED') {
          setSession(logeo.data.Session);
          setOpen(true);
          setLoading(false);
        } else if (
          logeo.data.AuthenticationResult !== null
          && logeo.data.AuthenticationResult !== undefined
        ) {
          const subValue = logeo.data.userInfo.id;
          const valueUserInfo = logeo.data.userInfo;
          const token = logeo.data.AuthenticationResult.IdToken;

          dispatch(authUserAction(subValue));
          dispatch(authUserInfo(valueUserInfo));

          sessionStorage.setItem('sub', subValue);
          sessionStorage.setItem('token', token);
          sessionStorage.setItem('infoUser', JSON.stringify(valueUserInfo));

          setLoading(false);
          navigate('/home');
        }
      }
    } catch (error) {
      const messageError = getMessageError(error.message);
      console.log(error.message);
      console.log(messageError);
      setErrorText(messageError);
      setLoading(false);
    }
  };
  const loginUser = () => {
    setOpen(false);
  };

  const closeModalChangePassword = () => {
    setOpen(false);
    setIsFirstLoging(true);
  };

  useEffect(() => {
    sessionStorage.setItem('sub', '');
    sessionStorage.setItem('token', '');
    if (location.state) {
      setIsFirstLoging(true);
    }
    setValues({
      user: '',
      password: '',
      showPassword: false,
    });
  }, []);
  const styleIconModal = (e) => <ErrorOutlineIcon className={e} />;
  return (
    <Card className={classes.card} noValidate>
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
        spacing={1}
      >
        <img
          className={classes.imageTalent}
          alt="logo-talent"
          src={logoTalent}
        />
      </Grid>
      {isFirstLoging ? (
        <PasswordFirstTime
          sessionLogin={session}
          setIsFirstLoging={setIsFirstLoging}
          userName={values.user}
        />
      ) : (
        <>
          <Grid
            container
            direction="column"
            justifyContent="center"
            alignItems="center"
          >
            <span className={classes.titleSession}>Iniciar sesión</span>
          </Grid>
          <Divider className={classes.sectionDivider} variant="middle" />
          <Grid
            container
            direction="column"
            justifyContent="center"
            alignItems="center"
          >
            <FormControl className={classes.titleForm}>
              <span className={classes.titleForm}>Usuario</span>
              <OutlinedInput
                className={classes.input}
                id="user"
                type="number"
                name="user"
                onChange={(event) => {
                  handleChange(event);
                }}
                margin="dense"
                value={values.user}
              />
            </FormControl>
            <FormControl>
              <span className={classes.titleForm}>Contraseña</span>
              <OutlinedInput
                className={classes.input}
                id="filled-adornment-password"
                type={values.showPassword ? 'text' : 'password'}
                name="password"
                margin="dense"
                value={values.password}
                onChange={(event) => {
                  handleChange(event);
                }}
                endAdornment={(
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {values.showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                )}
              />
            </FormControl>
            <Typography className={classes.forget} onClick={handleNavigateForgotPassword}>
              ¿Olvidaste tu contraseña?
            </Typography>
            <FormControl>
              <Button
                type="submit"
                size="large"
                className={classes.submit}
                onClick={login}
                open={open}
                onClose={loginUser}
                disabled={!(values.user && values.password && longValidUser)}
              >
                INICIAR SESIÓN
                {loading && (
                  <CircularProgress
                    size={24}
                    className={classes.buttonProgress}
                  />
                )}
              </Button>
            </FormControl>
            <FormControl>
              {errorText && (
                <Typography variant="caption" className={classes.textError}>
                  {errorText}
                </Typography>
              )}
            </FormControl>
          </Grid>
          <TransitionsModal
            open={open}
            textButton="OK"
            showCloseModalIcon={false}
            actionButton={closeModalChangePassword}
            textBody="Cambia tu contraseña por
                  una nueva que puedas recordar"
            icon={styleIconModal}
          />
          <TransitionsModal
            icon={styleIconModal}
            textBody="Tienes pendiente el cambio de tu
            contraseña, por favor ingresa a
           ¿Olvidaste tu contraseña?"
            open={openNeedChangePassword}
            textButton="ENTENDIDO"
            actionButton={validateIfNeedChangePassword}
            showCloseModalIcon={false}
          />
        </>
      )}
    </Card>
  );
}

export default Login;
